import { useEffect, useRef, useState } from 'react';

import moment from 'moment';

function INQCTableRow(props: { row: any }) {
  const { row } = props;

  const [elapsedTime, setElapsedTime] = useState<number>(0);
  const [totalElapsedTime, setTotalElapsedTime] = useState<number>(
    row?.inQcTime || 0
  );
  //   const [isRunning, setIsRunning] = useState(row?.isRunning || false);
  const [startTime, setStartTime] = useState<Date | null>(
    row?.lastQcStarted || null
  );
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (
      // isRunning &&
      startTime
    ) {
      intervalRef.current = setInterval(() => {
        const now = moment.utc().valueOf(); // Current UTC time in ms
        const start = moment.utc(startTime).valueOf(); // Start time in UTC ms
        const currentElapsedTime = (now - start) / 1000 + totalElapsedTime;
        setElapsedTime(currentElapsedTime);
      }, 1000);
    } else if (
      // !isRunning &&
      intervalRef.current
    ) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [
    // isRunning,
    startTime,
    totalElapsedTime,
  ]);

  const formatElapsedTime = (elapsedTimes: number) => {
    const days = Math.floor(elapsedTimes / (3600 * 24));
    const hours = Math.floor((elapsedTimes % (3600 * 24)) / 3600);
    const minutes = Math.floor((elapsedTimes % 3600) / 60);
    const seconds = Math.floor(elapsedTimes % 60);

    const daysStr = days > 0 ? `${days}d ` : '';
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');

    return `${daysStr}${hoursStr}:${minutesStr}:${secondsStr}`;
  };

  return <>{formatElapsedTime(elapsedTime)}</>;
}

export default INQCTableRow;
